"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFeedUpdateT = exports.DataFeedUpdate = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const bone_js_1 = require("../../solarxr-protocol/data-feed/bone.js");
const device_data_js_1 = require("../../solarxr-protocol/data-feed/device-data/device-data.js");
const server_guards_js_1 = require("../../solarxr-protocol/data-feed/server/server-guards.js");
const stay_aligned_pose_js_1 = require("../../solarxr-protocol/data-feed/stay-aligned/stay-aligned-pose.js");
const tracker_data_js_1 = require("../../solarxr-protocol/data-feed/tracker/tracker-data.js");
/**
 * All of the data components related to a single data feed. A data feed is comprised
 * of device data, and tracker data.
 *
 * A data feed might send data only when it changes/updates, and we should make no
 * assumptions that the data is actually delivered. If you want to guarantee
 * delivery and avoid dropped observations of data (such as a user-initiated
 * button press), it is better to use the RPC system.
 */
class DataFeedUpdate {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDataFeedUpdate(bb, obj) {
        return (obj || new DataFeedUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDataFeedUpdate(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DataFeedUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    devices(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new device_data_js_1.DeviceData()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    devicesLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    syntheticTrackers(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new tracker_data_js_1.TrackerData()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    syntheticTrackersLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    /**
     * This must represent a set, where there is no more than one bone for a `BodyPart`.
     */
    bones(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new bone_js_1.Bone()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    bonesLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    stayAlignedPose(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new stay_aligned_pose_js_1.StayAlignedPose()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    index() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    serverGuards(obj) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? (obj || new server_guards_js_1.ServerGuards()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startDataFeedUpdate(builder) {
        builder.startObject(6);
    }
    static addDevices(builder, devicesOffset) {
        builder.addFieldOffset(0, devicesOffset, 0);
    }
    static createDevicesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startDevicesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addSyntheticTrackers(builder, syntheticTrackersOffset) {
        builder.addFieldOffset(1, syntheticTrackersOffset, 0);
    }
    static createSyntheticTrackersVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startSyntheticTrackersVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addBones(builder, bonesOffset) {
        builder.addFieldOffset(2, bonesOffset, 0);
    }
    static createBonesVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startBonesVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addStayAlignedPose(builder, stayAlignedPoseOffset) {
        builder.addFieldOffset(3, stayAlignedPoseOffset, 0);
    }
    static addIndex(builder, index) {
        builder.addFieldInt8(4, index, 0);
    }
    static addServerGuards(builder, serverGuardsOffset) {
        builder.addFieldOffset(5, serverGuardsOffset, 0);
    }
    static endDataFeedUpdate(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new DataFeedUpdateT(this.bb.createObjList(this.devices.bind(this), this.devicesLength()), this.bb.createObjList(this.syntheticTrackers.bind(this), this.syntheticTrackersLength()), this.bb.createObjList(this.bones.bind(this), this.bonesLength()), (this.stayAlignedPose() !== null ? this.stayAlignedPose().unpack() : null), this.index(), (this.serverGuards() !== null ? this.serverGuards().unpack() : null));
    }
    unpackTo(_o) {
        _o.devices = this.bb.createObjList(this.devices.bind(this), this.devicesLength());
        _o.syntheticTrackers = this.bb.createObjList(this.syntheticTrackers.bind(this), this.syntheticTrackersLength());
        _o.bones = this.bb.createObjList(this.bones.bind(this), this.bonesLength());
        _o.stayAlignedPose = (this.stayAlignedPose() !== null ? this.stayAlignedPose().unpack() : null);
        _o.index = this.index();
        _o.serverGuards = (this.serverGuards() !== null ? this.serverGuards().unpack() : null);
    }
}
exports.DataFeedUpdate = DataFeedUpdate;
class DataFeedUpdateT {
    constructor(devices = [], syntheticTrackers = [], bones = [], stayAlignedPose = null, index = 0, serverGuards = null) {
        this.devices = devices;
        this.syntheticTrackers = syntheticTrackers;
        this.bones = bones;
        this.stayAlignedPose = stayAlignedPose;
        this.index = index;
        this.serverGuards = serverGuards;
    }
    pack(builder) {
        const devices = DataFeedUpdate.createDevicesVector(builder, builder.createObjectOffsetList(this.devices));
        const syntheticTrackers = DataFeedUpdate.createSyntheticTrackersVector(builder, builder.createObjectOffsetList(this.syntheticTrackers));
        const bones = DataFeedUpdate.createBonesVector(builder, builder.createObjectOffsetList(this.bones));
        const stayAlignedPose = (this.stayAlignedPose !== null ? this.stayAlignedPose.pack(builder) : 0);
        const serverGuards = (this.serverGuards !== null ? this.serverGuards.pack(builder) : 0);
        DataFeedUpdate.startDataFeedUpdate(builder);
        DataFeedUpdate.addDevices(builder, devices);
        DataFeedUpdate.addSyntheticTrackers(builder, syntheticTrackers);
        DataFeedUpdate.addBones(builder, bones);
        DataFeedUpdate.addStayAlignedPose(builder, stayAlignedPose);
        DataFeedUpdate.addIndex(builder, this.index);
        DataFeedUpdate.addServerGuards(builder, serverGuards);
        return DataFeedUpdate.endDataFeedUpdate(builder);
    }
}
exports.DataFeedUpdateT = DataFeedUpdateT;
